<!-- //NOTE - USAGE: Set session vars
  - session.bannerAlertMessage = "Message Here" -->
<div class="my-1 w-11/12 lanPixel2xl:w-4/5 rounded-lg z-50 mx-auto flex items-center gap-x-6 border border-yellow-800 bg-yellow-200 px-6 py-2.5" [ngClass]="{ hidden: !session.bannerAlertMessage, 'mt-[4rem]': !authService.getUser(), 'relative top-0': authService.getUser() }">
  <div class="text-1.5 font-bold text-yellow-600">{{ session.bannerAlertMessage }}</div>
  <div class="flex flex-1 justify-end">
    <button type="button" class="-m-3 p-3 focus-visible:outline-offset-[-4px]" (click)="session.bannerAlertMessage = undefined">
      <span class="sr-only">Dismiss</span>
      <ism-svg [name]="'xSquare'" [classString]="'w-8 h-8 text-yellow-800'"></ism-svg>
    </button>
  </div>
</div>
